import styled from "styled-components/macro";

import DonorSummaries from "./DonorSummaries";
import "./GiftsAndPledgesContainerQueries.scss";
import RecentGifts from "./RecentGifts";
import RecurringAndPledges from "./RecurringAndPledges";

export default function GiftsAndPledges() {
  return (
    <Wrapper className="gifts_and_pledges">
      <RecurringAndPledges />
      <RecentGifts isMobile />
      <DonorSummaries />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  color: #fff;
  display: flex;
  align-items: flex-start;
  gap: 40px;

  @media (max-width: 1000px) {
    display: grid;
    grid-auto-flow: row dense;
    grid-template-columns: auto 340px;
    grid-template-rows: auto 1fr;
    gap: 40px 40px;
    grid-template-areas:
      "recurring recents"
      "summaries recents";
    align-content: start;
  }
`;
